import { startHanziTool } from "./hanzi-tool.js";
import { startNumbersTool } from "./numbers-tool.js";
import { startScriptTool } from "./script-tool.js";
import { startSyllableTool } from "./syllable-tool.js";

/**
 * Which tool a page gets, and how it is started.
 *
 * Separate from `main.ts`, which is the bundle's entry point and does nothing
 * but call this on the document. Keeping the side effect in a module of its
 * own is what lets this one be imported and exercised without a page.
 */

/** What starts each tool, by the name its container gives. */
const starters = new Map<string, (container: HTMLElement) => void>([
  ["hanzi", startHanziTool],
  ["pinyin", startSyllableTool],
  ["bopomofo", startSyllableTool],
  ["numbers", startNumbersTool],
  ["script", startScriptTool],
]);

/**
 * Start whichever tools a page asked for.
 *
 * A page carrying no `data-cb-tool` at all starts nothing, which is every
 * other page on the site — though in practice the bundle is only loaded by the
 * tool layout, so they never see it.
 */
export function startTools(root: ParentNode): void {
  for (const container of root.querySelectorAll<HTMLElement>(
    "[data-cb-tool]",
  )) {
    const name = container.dataset["cbTool"];

    if (name !== undefined) {
      starters.get(name)?.(container);
    }
  }
}
